<div class="db-enable-tax-calc__content mt30">
  <div class="db-search-wrap">
    <ds-search-input *ngIf="taxRatesList?.length"
                     [width]="'260px'" [formControl]="searchTerm"
                     [hasSearchIcon]="true" [placeholder]="'text_searchEllipsis' | dbText">
    </ds-search-input>
  </div>
  <div class="ds-input-wrap static">
    <div (click)="clearFilter()" class="db-enable-tax-calc__clear-filter">
      <i class="db-icon db-icon-ds-restore1" *ngIf="!loadingBtn"></i>
      <span class="ds-spinner-circle" *ngIf="!!loadingBtn"></span>
    </div>
    <ds-dropdown *ngIf="taxRatesList?.length && !loadingBtn"
                 [dsDropdownOptions]="addRatesOptions"
                 [dsDropdownWidth]="'180px'"
                 (onOptionChoose)="filterByClass($event)"
                 [dsDropdownPlaceHolder]="'text_filter' | dbText"></ds-dropdown>
    <ds-dropdown *ngIf="taxRatesList?.length && !!loadingBtn"
                 [dsDropdownOptions]="addRatesOptions"
                 [dsDropdownWidth]="'180px'"
                 (onOptionChoose)="filterByClass($event)"
                 [dsDropdownPlaceHolder]="'text_filter' | dbText"></ds-dropdown>
    <ds-dropdown [dsDropdownOptions]="addRatesOptionsFilter"
                 [darkMode]="true"
                 [keepPlaceholder]="true"
                 (onOptionChoose)="addTaxRate($event)"
                 [color]="'black'"  [dsDropdownWidth]="'180px'"
                 [dsDropdownPlaceHolder]="'text_addRates' | dbText"></ds-dropdown>
  </div>
</div>
<div class="db-ecommerce-tax-rates-list-table mt30">
  <div class="fixed-row" [class.scrolled]="isScrollingHorizontal">
    <div class="row header-row first-column">
      <div class="cell" [innerHTML]="'text_rateType' | dbText"></div>
    </div>
    <div class="row first-column" *ngFor="let taxRate of (filteredTaxRatesList | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage}); let i = index">
      <div class="cell" [innerHTML]="((taxRate?.class | replaceTextWithBracers: { old: '-', new: ' '} ) | lowerCaseSpecificWords) || '*'"></div>
    </div>
  </div>

  <div class="content-row" (scroll)="onScroll($event)">
    <div class="row header-row">
      <div class="cell"
           *ngFor="let head of heads" [innerHTML]="head"></div>
    </div>
    <ng-container *ngIf="!filteredTaxRatesList?.length">
      <div class="row empty">
        <p>{{ 'text_noItemsFound' | dbText }}</p>
      </div>
    </ng-container>
    <ng-container *ngIf="!!filteredTaxRatesList?.length">
      <div class="row" *ngFor="let taxRate of (filteredTaxRatesList | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage}); let i = index">
        <div class="cell" [innerHTML]="taxRate?.country || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.state || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.postcode || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.city || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.rate || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.name || '*'"></div>
        <div class="cell" [innerHTML]="taxRate?.priority || '*'"></div>
        <div class="cell">
          <input class="ds-checkbox ds-checkbox-disabled-opacity" type="checkbox" [checked]="taxRate?.compound" id="compound-{{i}}">
          <label for="compound-{{i}}" class="ds-checkbox-label black"></label>
        </div>
        <div class="cell with-edit">
          <div>
            <input class="ds-checkbox ds-checkbox-disabled-opacity" type="checkbox" [checked]="taxRate?.shipping" id="shipping-{{i}}">
            <label for="shipping-{{i}}" class="ds-checkbox-label black"></label>
          </div>
          <i class="db-icon db-icon-ds-edit-website" (click)="editTaxRate(taxRate)"></i>
        </div>
      </div>
    </ng-container>
  </div>
</div>

